import { z } from 'zod';

// Environment variables schema
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url('Invalid API base URL'),
  VITE_AWS_REGION: z.string().min(1, 'AWS region is required'),
  VITE_USER_POOL_ID: z.string().min(1, 'User Pool ID is required'),
  VITE_USER_POOL_CLIENT_ID: z.string().min(1, 'User Pool Client ID is required'),
  VITE_ENVIRONMENT: z.enum(['development', 'staging', 'production']).default('development'),
  VITE_LOG_LEVEL: z.enum(['debug', 'info', 'warn', 'error']).default('info'),
  VITE_ENABLE_DEVTOOLS: z.string().transform(val => val === 'true').default('false'),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SENTRY_ENVIRONMENT: z.string().optional(),
  VITE_GA_TRACKING_ID: z.string().optional(),
  VITE_MOCK_API: z.string().transform(val => val === 'true').default('false'),
});

// Validate environment variables
const validateEnv = () => {
  try {
    return envSchema.parse(import.meta.env);
  } catch (error) {
    console.error('❌ Invalid environment variables:', error);
    throw new Error('Invalid environment configuration');
  }
};

// Export validated environment configuration
export const env = validateEnv();

// Environment helpers
export const isDevelopment = env.VITE_ENVIRONMENT === 'development';
export const isProduction = env.VITE_ENVIRONMENT === 'production';
export const isStaging = env.VITE_ENVIRONMENT === 'staging';

// API configuration
export const apiConfig = {
  baseURL: env.VITE_API_BASE_URL,
  timeout: 10000,
  retries: 3,
} as const;

// AWS Amplify configuration
export const amplifyConfig = {
  Auth: {
    Cognito: {
      region: env.VITE_AWS_REGION,
      userPoolId: env.VITE_USER_POOL_ID,
      userPoolClientId: env.VITE_USER_POOL_CLIENT_ID,
      loginWith: {
        email: true,
      },
    },
  },
} as const;

// Debug logging for Amplify configuration
console.log('🔍 Amplify Configuration Debug:', {
  userPoolId: env.VITE_USER_POOL_ID,
  userPoolClientId: env.VITE_USER_POOL_CLIENT_ID,
  environment: env.VITE_ENVIRONMENT,
  region: env.VITE_AWS_REGION
});

export default env;